import { render, staticRenderFns } from "./surveyPopup.vue?vue&type=template&id=5dbf4917&scoped=true&"
import script from "./surveyPopup.vue?vue&type=script&lang=js&"
export * from "./surveyPopup.vue?vue&type=script&lang=js&"
import style0 from "./surveyPopup.vue?vue&type=style&index=0&id=5dbf4917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbf4917",
  null
  
)

export default component.exports